import store from 'store2';

const KEYS = {
  SESSION_TOKEN: 'kea.app.session_token',
  USER_ID: 'kea.app.user_id',
  LOCALE: 'kea.app.locale',
  APP_START_MODE: 'kea.app.start_mode',
};

const storage = {
  sessionToken: {
    get: () => store.get(KEYS.SESSION_TOKEN),
    set: (token) => store.set(KEYS.SESSION_TOKEN, token),
    remove: () => store.remove(KEYS.SESSION_TOKEN),
  },

  userId: {
    get: () => store.get(KEYS.USER_ID),
    set: (userId) => store.set(KEYS.USER_ID, userId),
    remove: () => store.remove(KEYS.USER_ID),
  },

  locale: {
    get: () => store.get(KEYS.LOCALE),
    set: (locale) => store.set(KEYS.LOCALE, locale),
    remove: () => store.remove(KEYS.LOCALE),
  },

  appStartMode: {
    get: () => store.get(KEYS.APP_START_MODE),
    set: (mode) => store.set(KEYS.APP_START_MODE, mode),
  },

  clear: () => store.clear(),
};

export default storage;
